import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors, HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ToastrModule } from 'ngx-toastr';
import { OAuthModule } from 'angular-oauth2-oidc';
import { provideDayjsDateAdapter } from './core/date/dayjs-date-adapter';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { routes } from './app.routes';
import { loadingInterceptor } from './core/interceptor/loading.interceptor';
import { headerInterceptor } from './core/interceptor/header.interceptor';
import { terminatedAccessInterceptor } from './core/interceptor/terminated-access.interceptor';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

const APP_DATE_FORMATS = {
  parse: {
    dateInput: 'MM/DD/YYYY',
  },
  display: {
    dateInput: 'MM/DD/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding()),
    provideAnimations(),
    provideHttpClient(
      withInterceptors([loadingInterceptor, headerInterceptor, terminatedAccessInterceptor])
    ),
    provideDayjsDateAdapter(APP_DATE_FORMATS),
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
      ToastrModule.forRoot(),
      OAuthModule.forRoot()
    ),
  ],
};

